import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import { classesAPI } from 'api/classesAPI';
import { coachingAPI } from 'api/coachingAPI';
import { commonAPI } from 'api/commonAPI';
import Check from 'assets/images/icon/Check';
import CloseIcon from 'assets/images/icon/CloseIcon';
import axios from 'axios';
import { constCommon } from 'constants/constCommon';
import useGetCoachingData from 'hooks/useGetCoachingData';
import { cloneDeep } from 'lodash';
import {
  useLocation,
  useNavigate,
} from 'react-router-dom';
import {
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from 'recoil';
import {
  activeSubmit,
  fireSubmit,
  selectedMenu,
} from 'state';
import styled from 'styled-components';
import { isEmpty } from 'util/isEmpty';
import { DropdownMenu } from 'view/components';
import {fadeIn} from "../../../../../styled/StyledComponent";

interface StyledComponentProps {
    width?: string;
    display?: string;
    justifyContent?: string;
}

export type ClassesChapter = {
    id?: string | undefined;
    category?: string;
    chapterTitle?: string;
    jwPlayerList: ChapterVideo[];
};

export type ChapterVideo = {
    id: string;
    title: string;
    fileName?: string;
    preview: boolean;
};

const structure = {
    id: "",
    category: "",
    chapterTitle: "",
    jwPlayerList: [
        {
            id: "",
            title: "",
            fileName: "",
            preview: false,
        },
    ],
};

const viedoStructure = {
    id: "",
    title: "",
    fileName: "",
    preview: false,
};

const TYPES = [
    {
        contentType: "CLASSIC",
        price: 0,
        text: "Offer written coaching responses that are tailored to your client’s needs.",
    },
    {
        contentType: "VIDEO",
        price: 0,
        text: "Send video coaching responses, and create more meaningful connections with them.",
    },
    {
        contentType: "LIVE",
        price: 0,
        text: "Choose the price for a 10-minute coaching session, with the price going up as the length of the session increases. For instance, a 30-minute session would cost threetimes the price of a 10-minute session.",
    },
];

const Products: React.FC = () => {
    const menu = useRecoilValue(selectedMenu);
    const navigate = useNavigate();
    const {
        state: { createId },
    } = useLocation();
    const setSubmit = useSetRecoilState(activeSubmit);
    const [isLoading, setIsLoading] = useState(false);
    const [submitFire, setSubmitFire] = useRecoilState(fireSubmit);
    const { data: coachingData, stepData } = useGetCoachingData(
        createId,
        "getClassVideoById",
        isLoading
    );
    const [chapterData, setChapterData] = useState([structure]);
    const [percentage, setPercentage] = useState(0);
    const [uploadData, setUploadData] = useState(null);
    const [putData, setPutData] = useState({
        "24hr": true,
        coachingTypes: [],
        extraCharge: 0,
    })
    const [transcriptList, setTranscriptList] = useState([
        {
            fileName: "",
            file: null,
        },
    ]);
    const onClickPreview = (index: number, videoIndex: number, status: boolean) => {
        const copyData = cloneDeep(chapterData);
        copyData[index].jwPlayerList[videoIndex].preview = !status;
        setChapterData(cloneDeep(copyData));
    };

    const transcriptFileInput = useRef(null);

    const checkFileExtension = (fileName: string) => {
        const allowedExtensions =
            /(\.pdf|\.doc|\.docx|\.txt|\.rtf|\.html|\.csv|\.ppt|\.pptx|\.jpeg|\.png|\.gif)$/i;
        if (!allowedExtensions.exec(fileName)) {
            return false;
        }
        return true;
    };
    const isRightFileExtension = (file: any) => {
        const fileName = file?.name;
        if (!fileName) return false;

        const isRight = checkFileExtension(fileName);
        return isRight;
    };
    const handleTranscriptFile = (index: number) => {
        const file = transcriptFileInput.current?.files[0];
        const copy = cloneDeep(transcriptList);
        copy[index] = file;
        // if (!isRightFileExtension(file)) {
        //     alert("Please upload a file with the right extension");
        //     return;
        // }
        copy[index].fileName = file?.name;
        copy[index].file = file;
        setTranscriptList(copy);
    };

    const onClickPutProducts = async () => {
        const data = {
            ...cloneDeep(putData),
            is24hr:putData["24hr"],
            // coachingType:[]
            coachingType:cloneDeep(putData?.coachingTypes)
                ?.map((item) => {
                    delete item?.price["dropdownItem"];
                    delete item?.price["validTo"];
                    delete item?.price["validFrom"];
                return {
                    ...item,
                    price:item?.price?.purePrice
                }
            })
        }
        delete data["coachingTypes"]
        delete data["24hr"]
        console.log("@data",data);
        await coachingAPI.putCoachingProducts(createId, {
            data:cloneDeep(data)
        }).then(res => {
            if(!isEmpty(res)){
                navigate("/create_coaching/about",{
                    state:{
                        createId:createId
                    }
                })
            }
        })
    };
    const onClickPutProductsData = async () => {
        const formData = new FormData();
        const coachingType = cloneDeep(putData?.coachingTypes)?.map((item) => {
            return {
                contentType:item?.contentType,
                price:item?.price?.purePrice
            }
        });
        const data = {
            "is24hr":putData["24hr"],
            coachingType:cloneDeep(coachingType),
            extraCharge:putData?.extraCharge
        };
        formData.append("coachingType", JSON.stringify([]));
        formData.append("extraCharge", JSON.stringify(putData?.extraCharge));
        formData.append("is24hr", JSON.stringify(putData["24hr"]));
        delete data["coachingTypes"]
        await coachingAPI.putCoachingProducts(createId, {
            data:formData
        }).then(res => {
            if(!isEmpty(res)){
                navigate("/create_coaching/about",{
                    state:{
                        createId:createId
                    }
                })
            }
        })
    };
    console.log("@putData",putData);
    const checkCoachingType = (type) => {
        console.log("type", type);
        const c = cloneDeep(putData);
        const check = c?.coachingTypes?.find((findItem) => {
            return findItem?.contentType === String(type).toLocaleUpperCase();
        });
        console.log("c", c);
        if (!isEmpty(check)) {
            return true;
        } else {
            return false;
        }
    };
    const onClickTypeCheckbox = (type, obj) => {
        const c = cloneDeep(putData);
        const index = c?.coachingTypes?.findIndex((findItem) => {
            return findItem?.contentType === String(type).toLocaleUpperCase();
        });
        if (index === -1) {
            const copyData = cloneDeep(obj);
            delete copyData["text"];
            copyData.contentType = String(copyData.contentType).toLocaleUpperCase();
            c?.coachingTypes.push(copyData);
        } else {
            c?.coachingTypes?.splice(index, 1);
        }
        setPutData(cloneDeep(c));
    };
    const onClickCategoryMenu = (item, key, index) => {
        const copyData = cloneDeep(chapterData);
        copyData[index] = {
            ...copyData[index],
            [key]: item,
        };
        setChapterData(cloneDeep(copyData));
    };

    const onChangeVideoInput = (
        e: React.ChangeEvent<HTMLInputElement>,
        index: number,
        videoIndex: number
    ) => {
        const value = e.target.value;
        const copyData = cloneDeep(chapterData);
        copyData[index]["jwPlayerList"][videoIndex].title = value;
        console.log("copyData", copyData);
        setChapterData([...cloneDeep(copyData)]);
    };

    const setArrayData = (
        state: any,
        method: string,
        setState: any,
        index: number,
        viedoIndex?: number
    ) => {
        const data = cloneDeep(state);
        if (method === "add") {
            data[index]["jwPlayerList"]?.push(viedoStructure);
        } else {
            data[index]["jwPlayerList"]?.splice(viedoIndex, 1);
        }

        setState([...cloneDeep(data)]);
    };

    const setChapterList = (isAdd: boolean, index?: number) => {
        const copyData = cloneDeep(chapterData);
        if (isAdd) {
            copyData.push(structure);
            setChapterData([...copyData]);
        } else {
            copyData.splice(index, 1);
            setChapterData([...copyData]);
        }
    };

    const setTranscriptItems = (isAdd: boolean, index?: number) => {
        const copyData = cloneDeep(transcriptList);
        if (isAdd) {
            copyData.push({
                fileName: "",
                file: null,
            });
            setTranscriptList([...copyData]);
        } else {
            copyData.splice(index, 1);
            setTranscriptList([...copyData]);
        }
    };

    const deleteVideoId = async () => {
        // await classesAPI.deleteClassByVideoId()
    };

    const handleUploadJWP = async (event, index, videoIndex, chapterData) => {
        const copyData = cloneDeep(chapterData);
        const file = event.target.files[0];

        if (copyData[index]["jwPlayerList"][videoIndex]?.title.length === 0) {
            alert("Please enter a video title");
            return;
        }
        if (!file) {
            return;
        }

        try {
            const result = await commonAPI.postVideoMetadata({
                data: {
                    metadata: {
                        title: copyData[index]["jwPlayerList"][videoIndex]?.title,
                    },
                    upload: {
                        mimeType: file?.type,
                    },
                    fileName: file?.name,
                    preview: true,
                },
            });
            if (result) {
                console.log("result", result);
                const uploadLink = result.data.upload_link;
                copyData[index]["jwPlayerList"][videoIndex].id = result?.data?.jwPlayerId;
                copyData[index]["jwPlayerList"][videoIndex].fileName = file?.name;
                copyData[index]["jwPlayerList"][videoIndex].preview = result?.data?.preview || true;
                if (result?.data?.jwPlayerId) {
                    setChapterData(cloneDeep(copyData));
                }

                const fileReader = new FileReader();
                fileReader.readAsArrayBuffer(file);
                fileReader.onload = async () => {
                    const arrayBuffer = fileReader.result as ArrayBuffer;
                    const uint8Array = new Uint8Array(arrayBuffer);
                    const buffer = uint8Array.slice();
                    axios({
                        method: "PUT",
                        url: uploadLink,
                        headers: {
                            "Content-Type": file?.type,
                        },
                        data: new Blob([buffer]),

                        onUploadProgress: (progressEvent) => {
                            const percentage =
                                (progressEvent.loaded / (progressEvent.total || 1)) * 100;
                            const percentCompleted = Math.round(percentage);
                            setPercentage(percentCompleted);
                        },
                    }).then(async (res) => {
                        console.log("video", res);
                        await putVideoData(false, copyData).then((res) => {
                            classesAPI.getClassVideoById(createId).then((res) => {
                                dataSetting(res?.data);
                            });
                        });
                    });
                };
            }
        } catch (error) {
            console.log("error", error);
        }
    };
    const putVideoData = async (routing = true, chapter) => {
        await classesAPI
            .putClassVideo(createId, {
                data: getFormData(chapter),
            })
            .then((res) => {
                // setIsLoading(v => !v)
                if (routing) {
                    console.log("upload", res);
                    navigate("/create/quiz", {
                        state: {
                            createId: createId,
                        },
                    });
                }
            });
    };
    const getFormData = (chapterData) => {
        const formData = new FormData();
        if (transcriptList.length > 0) {
            transcriptList.forEach((transcript) => {
                if (transcript?.file) {
                    const transcriptBlob = new Blob([transcript?.file], {
                        type: transcript.file.type,
                    });
                    formData.append("transcriptFiles", transcriptBlob, transcript?.file?.name);
                }
            });
        }

        const copy = cloneDeep(chapterData)?.map((item) => {
            item.jwPlayerList = item?.jwPlayerList?.filter((item) => {
                return !isEmpty(item?.id);
            });
            if (isEmpty(item.id)) {
                delete item.id;
            }
            return item;
        });
        console.log("copy", copy);

        const chapterList = JSON.stringify(copy);
        formData.append("requestChapterList ", chapterList || "[]");

        return formData;
    };

    console.log("transcriptList2", transcriptList);

    const onClickDeleteChapter = async (id) => {
        await classesAPI.deleteClassChapter(createId, id, null).then((res) => {
            console.log("suc", res);
        });
    };

    const getPrice = (item:any) => {
        const data = putData?.coachingTypes?.find(
            (findItem) => {
                return (
                    findItem?.contentType ===
                    String(item?.contentType)?.toLocaleUpperCase()
                );
            }
        )?.price?.purePrice;

        return data;
    }
    const dataSetting = (stepData) => {
        if (stepData?.transcripts && stepData?.transcripts?.length !== 0) {
            setTranscriptList(stepData?.transcripts);
        }
        if (stepData?.chapterList && stepData?.chapterList?.length !== 0) {
            const viedoData = [
                {
                    id: "",
                    title: "",
                    fileName: "",
                    preview: false,
                },
            ];
            const mapData = stepData?.chapterList?.map((item) => {
                return {
                    id: item?.id,
                    category: item?.category,
                    chapterTitle: item?.chapterTitle,
                    jwPlayerList:
                        cloneDeep(item?.videos).length === 0 ? viedoData : cloneDeep(item?.videos),
                };
            });
            setChapterData(cloneDeep(mapData));
        }
    };

    useEffect(()=>{
        setPutData(
            {
                "24hr": coachingData?.coaching?.["24hr"],
                coachingTypes: cloneDeep(coachingData?.coaching?.coachingTypes),
                extraCharge: isEmpty(coachingData?.coaching?.extraCharge) ? 0 : coachingData?.coaching?.extraCharge,
            }
        )
    }, [coachingData?.coaching]);

    console.log("coachingData", coachingData)
    useEffect(() => {
        dataSetting(stepData);
    }, [stepData]);

    useEffect(() => {
        if (!isEmpty(chapterData)) {
            setSubmit(true);
        } else {
            setSubmit(false);
        }
    }, []);

    useEffect(() => {
        if (!isEmpty(coachingData)) {
            setUploadData(cloneDeep(coachingData));
        }
    }, [coachingData]);

    useEffect(() => {
        if (submitFire) {
            setSubmitFire(false);
            //   putVideoData();
        }
    }, [submitFire]);

    console.log("coachingData", coachingData);
    console.log("chapterData", chapterData);
    console.log("putData", putData);

    return (
        <Container>
            <Contents>
                <h2
                    style={{
                        fontWeight: "700",
                        fontSize: 26,
                        marginBottom: 15,
                        color:"#333"
                    }}
                >
                    Coaching Type
                    <strong
                       style={{
                           color:"#da1414"
                       }}
                    >*</strong>
                </h2>
                <SubTitle>
                    Select one or more coaching formats to engage your students and share your
                    expertise.
                </SubTitle>
                <FormItems>
                    <FormInner>
                        {TYPES?.map((item) => {
                            return (
                                <Row display={"flex"}>
                                    {chapterData?.length !== 1 && (
                                        <CloseButton onClick={() => {}}>
                                            <CloseIcon />
                                        </CloseButton>
                                    )}
                                    <Col style={{ width: "50%" }}>
                                        <FormBox>
                                            <CheckBox
                                                onClick={() => {
                                                    onClickTypeCheckbox(item?.contentType, item);
                                                }}
                                            >
                                                <div
                                                    className={
                                                        checkCoachingType(item?.contentType)
                                                            ? "on"
                                                            : ""
                                                    }
                                                >
                                                    <Check />
                                                </div>
                                                <span
                                                    style={{
                                                        textTransform:"capitalize"
                                                    }}
                                                className={"type"}
                                                >{String(item?.contentType)?.toLowerCase()}</span>
                                            </CheckBox>
                                            <p className={"desc"}>{item?.text}</p>
                                            <dd>
                                                <FormBoxItemWrap>
                                                    <FormItem
                                                        style={{
                                                            pointerEvents: !checkCoachingType(
                                                                item?.contentType
                                                            )
                                                                ? "none"
                                                                : "all",
                                                            opacity: !checkCoachingType(
                                                                item?.contentType
                                                            )
                                                                ? 0.5
                                                                : 1,
                                                        }}
                                                    >
                                                        <DropdownMenu
                                                            selected={
                                                                (getPrice(item) == 0 ? "Free" : isEmpty(getPrice(item)) ? "" : `$${getPrice(item)}`) ?? ""
                                                            }
                                                            altText={"Select price"}
                                                            items={
                                                                constCommon.CLASSES_PRICE.map(
                                                                    (priceItem) => {
                                                                        return {
                                                                            ...priceItem,
                                                                            dropdownItem:`$${priceItem.purePrice}`
                                                                        };
                                                                    }
                                                                ) || []
                                                            }
                                                            state={"category"}
                                                            index={0}
                                                            onClick={(...rest) => {
                                                                const c = cloneDeep(putData);
                                                                const findData =
                                                                    c?.coachingTypes?.find(
                                                                        (findItem) => {
                                                                            return (
                                                                                findItem.contentType ===
                                                                                String(item?.contentType).toLocaleUpperCase()
                                                                            );
                                                                        }
                                                                    );
                                                                console.log("@rest",rest);
                                                                findData.price = rest[3];
                                                                setPutData(c);
                                                                console.log(
                                                                    "selectedItem",
                                                                    rest[3]
                                                                );
                                                            }}
                                                        />
                                                    </FormItem>
                                                </FormBoxItemWrap>
                                            </dd>
                                        </FormBox>
                                    </Col>
                                </Row>
                            );
                        })}
                    </FormInner>
                </FormItems>

                <Divider />

                <h2
                    style={{
                        fontWeight: "700",
                        fontSize: 26,
                        marginBottom: 15,
                        marginTop: 30,
                    }}
                >
                    Coaching Option
                </h2>
                <SubTitle>Add more value to your coaching with extra options.</SubTitle>
                <FormItems style={{ marginBottom: 0 }}>
                    <FormInner>
                        <Row display={"flex"} style={{ paddingTop: "5px" }}>
                            {chapterData?.length !== 1 && (
                                <CloseButton onClick={() => {}}>
                                    <CloseIcon />
                                </CloseButton>
                            )}
                            <Col style={{ width: "100%" }}>
                                <FormBox>
                                    <CheckBox onClick={() => {  
                                        const c = cloneDeep(putData);
                                        if(c['24hr']){
                                            c.extraCharge = 0
                                        }
                                        c['24hr'] = !c['24hr']
                                        setPutData(cloneDeep(c));
                                    }}>
                                        <div className={putData["24hr"] ? "on" : ""}>
                                            <Check />
                                        </div>
                                        <span>24hr delivery</span>
                                    </CheckBox>
                                    <p>
                                        If your students select this option, you would send an
                                        answer in 24hrs both for classic and video coaching.
                                    </p>
                                    <dd>
                                        <FormBoxItemWrap style={{width:"50%"}}>
                                            <FormItem
                                                style={{
                                                    pointerEvents: putData["24hr"] === false
                                                        ? "none"
                                                        : "all",
                                                    opacity: putData["24hr"] === false
                                                        ? 0.5
                                                        : 1,
                                                }}
                                            >
                                                <DropdownMenu
                                                    selected={(putData["24hr"] === false || isEmpty(putData?.extraCharge)) ? "" : (putData.extraCharge == 0 ? "Free" : `$${putData.extraCharge}`)}
                                                    altText={"Select price"}
                                                    items={
                                                        constCommon.CLASSES_PRICE.map(
                                                            (priceItem) => {
                                                                return {
                                                                    ...priceItem,
                                                                    dropdownItem:priceItem.purePrice == 0 ? "Free" : `$${priceItem.purePrice}`,
                                                                };
                                                            }
                                                        ) || []
                                                    }
                                                    maxHeight={190}
                                                    state={"price"}
                                                    index={0}
                                                    onClick={(...rest)=>{
                                                        console.log('rest', rest)
                                                        const c = cloneDeep(putData);
                                                        c.extraCharge = rest[3]?.purePrice
                                                        setPutData(cloneDeep(c))
                                                    }}
                                                />
                                            </FormItem>
                                        </FormBoxItemWrap>
                                    </dd>
                                </FormBox>
                            </Col>
                        </Row>
                    </FormInner>
                </FormItems>
            </Contents>
            <ButtonItems
                onClick={async () => {
                    // putVideoData(true, chapterData);
                    await onClickPutProducts()
                }}
                justifyContent={"flex-end"}
            >
                <Browse
                    className={"prev"}
                    style={{ marginRight: 15, width: 100, height: 40 }}>
                    <span style={{ marginLeft: 0 }}>Previous</span>
                </Browse>
                <button
                    className={"continue"}
                >Continue</button>
            </ButtonItems>
        </Container>
    );
};
export default Products;

const Container = styled.div`
    //overflow-y: scroll;
    animation: ${fadeIn} 0.3s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;

    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
    }
`;

const Contents = styled.div`
    padding: 20px;
`;
const SubTitle = styled.h3`
    color: #333;
    font-weight: 400;
    font-size: 18px;
    font-style: normal;
    line-height: 26px;
    margin-bottom: 16px;
`;
const Row = styled.div<StyledComponentProps>`
    display: ${(props) => props.display};
    justify-content: space-between;
    margin-bottom: 16px;
`;
const Col = styled.div<StyledComponentProps>`
    width: calc((100% - 18px) / 2);
    @media screen and (max-width: 768px) {
        width: 100% !important;
    }
`;
const Divider = styled.div`
    width: calc(100%);
    height: 0.6px;
    background: #333;
    opacity: 0.3;
`;
const CheckOption = styled.div``;
const FormBox = styled.dl`
    > dt {
        font-size: 16px;
        font-weight: 400;
        color: #333;
        opacity: 0.8;
        > strong {
            font-size: 13px;
            font-weight: 600;
            color: #da1414;
            display: inline-block;
            margin-left: 1px;
            vertical-align: top;
        }
    }
    p {
        //font-weight: 400px;
        //font-size: 14px;
        //margin-top: 12px;
        //margin-bottom: 12px;
        //opacity: 0.8;
        //line-height: 18px;
        margin-top: 12px;
        margin-bottom: 12px;
        color: #333;
        font-size: 16.3px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
    }
`;
const FormBoxItemWrap = styled.ul`
    > li {
        font-size: 16px;
        margin: 8px 0 0 0;
    }
    @media screen and (max-width: 768px) {
        width: 100% !important;
    }
`;

const FormItem = styled.div`
    transition: all 0.2s;
    width: 100%;
    height: 48px;
    > input[type="text"],
    select,
    textarea {
        transition: all 0.2s;
        width: 100%;
        font-family: Europa-Regular;
        font-size: 16px;
        outline: none;
        border-radius: 8px;
        border: solid 1px rgba(51, 51, 51, 0.3);
        padding: 12px 16px;
        &::placeholder {
            color: #ddd;
        }
    }
    > input[type="text"] {
        height: 48px;
    }
    > select {
        height: 48px;
        -webkit-appearance: none;
        appearance: none;
    }
`;

const TextLength = styled.span`
    color: rgba(51, 51, 51, 0.6);
    font-weight: 700;
    position: absolute;
    right: 16px;
    top: 17px;
`;

const SelectArrow = styled.div`
    position: absolute;
    right: 16px;
    top: 15px;
`;

const ThumbnailWrap = styled.div`
    color: #333;
    font-size: 16px;
`;

const ThumbnailTitle = styled.h5`
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 15px;
    > strong {
        font-size: 13px;
        font-weight: 600;
        color: #da1414;
        display: inline-block;
        margin-left: 1px;
        vertical-align: top;
    }
`;

const ThumbnailText = styled.p`
    margin-bottom: 15px;
    line-height: 22px;
`;

const ThumbnailUpload = styled.div`
    width: 100%;
    height: 180px;
    padding: 9px 8px;
    border: 1px dashed rgba(51, 51, 51, 0.6);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    button {
        padding: 0;
        border: 0;
        background: none;
        line-height: 0;
        cursor: pointer;
    }
`;

const ThumbnailView = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    &::after {
        width: 100%;
        height: 100%;
        position: absolute;
        background: #000;
        opacity: 0.5;
        content: "";
    }
`;

const ThumbnailButtonList = styled.ul`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    > li {
        margin: 0 4px;
    }
`;

const ThumbnailUploadButton = styled.button`
    width: 100%;
    height: 100%;
    > span {
        display: block;
        font-size: 18px;
        font-family: Europa-Regular;
        margin-top: 10px;
        line-height: 100%;
    }
`;

const ButtonItems = styled.div<StyledComponentProps>`
    padding: 25px 20px;
    display: flex;
    justify-content: space-between;
    border-top: solid 0.6px rgba(51, 51, 51, 0.3);
    button {
        width: 100px;
        height: 40px;
        border: 0;
        cursor: pointer;
        padding: 11px 15px 11px 14px;
        color: #fff;
        border-radius: 6px;
        background: #ddc160;
    }
`;

const FormItems = styled.div`
    margin-bottom: 30px;
    position: relative;

    border: 0.6px solid rgba(51, 51, 51, 0.6);
    border-radius: 15px !important;
    box-shadow: 0px 0px 6px 0px #33333329;
`;
const FormInner = styled.div`
    padding: 15px 15px 10px 15px;
    .type{
        text-transform: capitalize;
        color: #333;
        font-size: 16px;
        font-style: normal;
        font-family: "Europa-Bold";
        font-weight: 700!important;
    }
    .desc{
        color: #333;
        opacity: 1;
        font-size: 16.3px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        margin-bottom: 10px;
    }
`;

const FormItemDivider = styled.div`
    width: 100%;
    height: 1px;
    background: #33333360;
`;
const VideoItemsWrap = styled.div`
    padding: 30px 15px 20px 15px;
    h2 {
        color: #000;
        margin-bottom: 3px;
        font-size: 16px;
        font-weight: 400;
    }
`;
const VideoItems = styled.div`
    display: flex;
    transition: all 0.2s;
    align-items: center;
    margin-bottom: 15px;
`;
const CheckBox = styled.div`
    display: flex;
    cursor: pointer;
    margin-right: 13px;
    align-items: center;
    span {
        font-size: 16px;
        color: #212529;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 150%;
    }

    div {
        cursor: pointer;
        transition: all 0.2s;
        padding: 0;
        width: 16px;
        height: 16px;
        margin-right: 8px;
        border-radius: 4px;
        border: solid 1px #333;
        display: flex;
        align-items: center;
        justify-content: center;
        &.on {
            border: solid 1px #ddc160;
            background: #ddc160;
        }
    }
`;
const Browse = styled.div`
    position: relative;
    cursor: pointer;
    height: 48px;
    border-radius: 8px;
    padding: 0 18.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px #333;
    flex: 1;
    width: 100%;
    max-width: 120px;
    transition: all 0.2s;
    &:hover{
        background: #333;
        span{
            color: #fff;
        }
    }
    &.prev{
        width: 100px;
        max-width: 100px;
        padding: 0!important;
        @media screen and (max-width: 768px) {
            margin: 0!important;
        }
    }
    span {
        margin-left: 10px;
    }
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    input {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #333;
        opacity: 0;
        z-index: 3;
    }
`;
const CloseButton = styled.div`
    background: #333;
    position: absolute;
    right: 0;
    z-index: 2;
    top: 0;
    width: 51px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    svg {
        pointer-events: none;
    }
`;
const RemoveButton = styled.div``;

const AddButton = styled.div`
    height: 48px;
    cursor: pointer;
    border-radius: 8px;
    padding: 0 18.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px #333;

    width: 129px;
`;

const AddChapter = styled.div`
    background: #333;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    width: 160px;
    height: 40px;
    justify-content: center;
    border-radius: 5px;
    cursor: pointer;
    span {
        color: #fff;
        font-size: 18px;
        margin-left: 10px;
        font-weight: 400;
    }
`;

const Transcript = styled.div`
    h3 {
        margin-top: 20px;
        margin-bottom: 14px;
        font-size: 26px;
        font-weight: 700;
    }
`;

const TranscriptTitle = styled.h3`
    font-size: 26px;
    font-weight: 700;
    margin-bottom: 16px;
    margin-top: 20px;
`;
